export default __webpack_public_path__ + "8c0831548ab6656f02dd6d3bf7a34210.png";